var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpe-page-header"},[_c('DgBreadcrumb',{on:{"buttonClick":_vm.backToIndustryPage}}),_c('div',{staticClass:"cpe-page-header-industry"},[_vm._v("Industry: "+_vm._s(_vm.industry))]),_c('div',{staticClass:"cpe-page-header-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }